import React, { Component } from 'react';
import { PropTypes as PT } from 'prop-types';
import MainSpinner from 'components/MainSpinner/MainSpinner';
import ChatWindowContainer from 'containers/Chat/ChatWindow/ChatWindowContainer';
import classes from './Chat.module.scss';
import ChatListComp from './ChatList';

class Chat extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false
    };
  }

  UNSAFE_componentWillMount() {
    this.setState({ loading: true });
  }

  componentDidMount() {
    window.addEventListener('visibilitychange', this.handleFocus);

    const { conversationContactDialString, conversation, conversationMode, onSelectContact,
      onSetChatMode, endRouteLoading } = this.props;

    setTimeout(() => {
      this.setState({ loading: false });
      endRouteLoading();
    }, 0);

    /* select the lastConversationContactDialString when re-opening the app, but
     * only if the contact is still listed in the current chat contacts.
     * Only perform this check if the app is being
     * re-opened (if conversationMode === 'new') */
    if (conversationContactDialString && (conversationMode === 'new')) {
      onSelectContact(conversation && conversation.contact, true);
    } else if (conversationMode === 'new') {
      onSetChatMode();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('visibilitychange', this.handleFocus);
  }

  handleFocus = () => {
    if (!document.hidden) {
      this.props.markConversationAsRead(this.props.conversation);
    }
  };

  startNewChat = () => {
    const { onSelectConversation, onSetChatMode } = this.props;

    onSelectConversation({ contact: {} });
    onSetChatMode('search');
  };

  render() {
    const { conversationContactDialString, conversations, isFirstUse,
      onLeaveConversation, onSelectConversation,
      markConversationAsRead, hiddenByCall
    } = this.props;

    if (hiddenByCall) {
      return null;
    }

    if (this.state.loading) {
      return (<MainSpinner showDelay />);
    }

    return (
      <div className={classes.chatContainer}>
        <div className={classes.chatList}>
          <ChatListComp
            conversationContactDialString={conversationContactDialString}
            conversations={conversations}
            isFirstUse={isFirstUse}
            onStartNewChat={this.startNewChat}
            onLeaveConversation={onLeaveConversation}
            onSelectConversation={onSelectConversation}
            markConversationAsRead={markConversationAsRead}
          />
        </div>
        <div
          className={classes.chatWindow}
          id="chatWindowDivContainer"
        >
          <ChatWindowContainer
            onStartNewChat={() => this.startNewChat()}
          />
        </div>
      </div>
    );
  }
}

Chat.propTypes = {
  conversation: PT.object,
  conversationContactDialString: PT.string,
  conversationMode: PT.string,
  conversations: PT.object,
  endRouteLoading: PT.func,
  isFirstUse: PT.bool,
  onLeaveConversation: PT.func,
  onSelectContact: PT.func,
  onSelectConversation: PT.func,
  onSetChatMode: PT.func,
  markConversationAsRead: PT.func,
  hiddenByCall: PT.bool
};

export default Chat;
